import Account from "pages/Account/Account";
import AppsPage from "pages/Apps";
import BlockchainPage from "pages/BlockchainPage";
import Devices from "pages/Devices";
import ForgotPassword from "pages/ForgotPassword";
import IPTablePage from "pages/IPTablePage";
import Login from "pages/Login";
import AccessManagement from "pages/Management/AccessManagement";
import OrganizationManagement from "pages/Management/OrganizationManagement";
import ManagePlansPage from "pages/ManagePlans";
import MultiDashboardPage from "pages/MultiDashboard";
import Networks from "pages/Networks";
import PricingPlansPage from "pages/PricingPlansPage";
import RemoteConsolePage from "pages/RemoteConsole";
import ResetPassword from "pages/ResetPassword";
import SignUp from "pages/Signup";
import SingleDashboardPage from "pages/SingleDashboard";
import SingleNetworkPage from "pages/SingleNetworkPage";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import SubscriptionPage from "../../pages/Subscription";
import PrivateLayoutRoutes from "./PrivateLayoutRoutes";
import PrivateNoLayoutRoutes from "./PrivateNoLayoutRoutes";
import PrivateSubscriptionRoutes from "./PrivateSubscriptionRoutes";


const MyRouter = () => {

  return (
    <Router>
      <Routes>
        <Route element={<PrivateLayoutRoutes />}>
          <Route path="/devices" element={<Devices />} />
          <Route path="/apps" element={<AppsPage />} />
          <Route path="/single-dashboard/:id" element={<SingleDashboardPage />} />
          <Route path="/ip-table/:id" element={<IPTablePage />} />
          <Route path="/" element={<MultiDashboardPage />} />
          <Route path="/account" element={<Account />} />
          <Route path="/portal-access-management" element={<AccessManagement />} />
          <Route path="/organization-access-management" element={<OrganizationManagement />} />
          {/* <Route path="/networks" element={<Networks />} /> */}
          <Route path="/single-network/:id" element={<SingleNetworkPage />} />
          <Route path="/blockchain/tx/:txnId" element={<BlockchainPage />} />
          <Route path="/manage-plans" element={<ManagePlansPage />} />
        </Route>

        <Route element={<PrivateNoLayoutRoutes />}>
          <Route path="/console" element={<RemoteConsolePage />} />
        </Route>

        <Route element={<PrivateSubscriptionRoutes />}>
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/pricing" element={<PricingPlansPage />} />
        </Route>


        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </Router>
  );
};

export default MyRouter;
